import React from 'react';
import { clsx } from 'clsx';

export interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className }) => {
  return (
    <div className={clsx('breadcrumbs text-sm', className)}>
      <ul>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const content = (
            <>
              {item.icon && <span className="mr-2">{item.icon}</span>}
              {item.label}
            </>
          );

          return (
            <li key={index}>
              {item.href && !isLast ? (
                <a href={item.href} onClick={item.onClick}>
                  {content}
                </a>
              ) : item.onClick && !isLast ? (
                <button onClick={item.onClick} className="btn-ghost">
                  {content}
                </button>
              ) : (
                <span className={!isLast ? 'cursor-pointer' : ''}>{content}</span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
